import React from "react";
import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../../../features/tasks/tasksApi";
import Task from "./Task";

const Tasks = () => {
  const { filterProjects } = useSelector((state) => state.projects);
  const { search } = useSelector((state) => state.filter);
  const { isError, isLoading, data } = useGetTasksQuery();

  // decide what to render based on the state of the query
  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong</div>;
  }
  if (!isLoading && !isError && data.length > 0 && filterProjects.length > 0) {
    content = data
      .filter((task) => filterProjects.includes(task.project.projectName))
      // eslint-disable-next-line array-callback-return
      .filter((task) => {
        if (search === "") {
          return task;
        } else if (task.taskName.toLowerCase().includes(search.toLowerCase())) {
          return task;
        }
      })
      .map((task) => <Task key={task.id} {...task} />);
  }

  return <div className="lws-task-list">{content}</div>;
};

export default Tasks;
